module.exports = __webpack_public_path__ + "static/media/modelo-confirm-email.d53a942a.png";